module.exports = __webpack_public_path__ + "img/msg1.5ba41434.png";